import React from 'react';
import { TextField } from '@mui/material';
import { useChartEditContext } from './ChartEditContext';

export default function ChartLegacyInputs() {
  const { chart, editedChart, setEditedChart } = useChartEditContext();

  return (
    <div className="flex flex-wrap">
      <p className="w-full">
        Visible only to admin:
      </p>

      <div className="w-full sm:w-1/3">
        <div className="section">
          <TextField
            variant="filled"
            multiline
            placeholder="raw"
            name="raw"
            fullWidth
            onChange={(e) => { setEditedChart(draft => { draft.raw = e.target.value }) }}
            rows={3}
            value={editedChart.raw || ''}
          />
        </div>
      </div>

      <div className="w-full sm:w-1/3">
        <div className="section">
          <TextField
            variant="filled"
            multiline
            placeholder="chords_old"
            name="chords_old"
            fullWidth
            onChange={(e) => { setEditedChart(draft => { draft.chords_old = e.target.value }) }}
            rows={3}
            value={editedChart.chords_old || ''}
          />
        </div>
      </div>

      <div className="w-full sm:w-1/3">
        <div className="section">
          <TextField
            variant="filled"
            multiline
            placeholder="lyrics_old"
            name="lyrics_old"
            fullWidth
            onChange={(e) => { setEditedChart(draft => { draft.lyrics_old = e.target.value }) }}
            rows={3}
            value={editedChart.lyrics_old || ''}
          />
        </div>
      </div>
    </div>
  )
}
